import { Flex } from "@chakra-ui/react";

interface TagStatusProps {
  titulo: string;
  color?: string;
}

export default function TagStatus({ titulo, color }: TagStatusProps) {
  return (
    <Flex
      rounded={15}
      border={`solid 1px ${color}`}
      color={color}
      px={2}
      w="fit-content"
    >
      {titulo}
    </Flex>
  );
}
